document.addEventListener('DOMContentLoaded', function() {
  const seFilterTrigger = document.querySelector('.se-filters');
  const seFilter = document.querySelectorAll('.facets__wrapper');
  const seFilters = seFilter.length > 1 ? seFilter[1] : seFilter[0];
  const seFilterMobile = document.querySelector('.se-filters-mobile');

  if(seFilterTrigger){
    seFilterTrigger.addEventListener("click", function(e){
      e.preventDefault();
      seFilters.classList.toggle('se-filters-opened');
      seFilterMobile.classList.toggle('se-filters-opened');
    });
  }
  
  document.querySelectorAll('.facets__disclosure').forEach(function (summaryText) {
    summaryText.addEventListener('click', function () {
      const showMorePanel = this.querySelector('.show-more_panel');
      if (showMorePanel) {
        this.classList.toggle('se-panel-opened');
        showMorePanel.classList.toggle('active');
      }
    });
  });

  document.querySelectorAll('.se-order-name').forEach(function (button) {
    button.addEventListener('click', function (e) {
      if(window.innerWidth <= 480) {
        e.preventDefault();
        
        const orderId = this.getAttribute('data-order');
        const suborder = document.querySelector('.se-suborder[data-order="' + orderId + '"]');
  
        console.log(orderId);
  
        if (suborder) {
          suborder.classList.toggle('se-order-active');
        }
      }
    });
  });

});